export const BASEROW_ACADEMY_URL = 'https://academy.baserow.io/'
